import React from "react";
import ReactDOM from "react-dom/client";
import "./Styles/Master/index.scss";
import App from "./Components/Master/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
